import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-unknow-user',
  templateUrl: './unknow-user.component.html',
  styleUrls: ['./unknow-user.component.scss']
})
export class UnknowUserComponent {

  constructor() { }

}
